// extracted by mini-css-extract-plugin
export var label = "_ih-2";
export var slideContainer = "_ih-0";
export var slider = "_ih-1";